/**
 * 五角星收藏相关
 */
import { productCollection, cancelProductCollection, notifyWashingMachine } from '@/http/service/goods'

export default {
  data() {
    return {
      isCollected: 0, // 是否收藏，1收藏0没收藏
      // 通知洗衣机相关的字段
      taskId: '',
      stageId: '',
    }
  },
  watch: {
    // 生成专属价replace跳转监听
    // $route(to, from) {
    //   if (from.name === 'detail' && to.name === 'detail') {
    //     this.init()
    //   }
    // },
    isCollected: {
      handler(newVal) {
        if (newVal) {
          this.notifyWashingMachine()
        }
      },
      immediate: true,
    },
  },
  created() {
    this.taskId = this.$route.query.taskId || ''
    this.stageId = this.$route.query.stageId || ''
  },
  methods: {
    /**
     * @description 商品收藏,取消收藏
     */
    fnCollect() {
      
      if (this.islogining) return
      // 未登录处理
      if (!this.$store.getters.getLoginStatus) {
        this.islogining = true
        this.$store
          .dispatch('doLogin')
          .then((res) => {
            if (res !== 400) {
              this.islogining = false
              this.reload()
            } else {
              this.islogining = false
            }
          })
          .catch(() => {
            this.islogining = false
          })
        return
      }
      if (this.$util.isShopKeeper()) {
        this.$util.gioTrackWithVariable(
          'YG20101',
          {
            status: this.isCollected ? '取消收藏' : '收藏',
            product_id: this.productId,
            product_name: this.products?.productFullName,
            md_code: this.storeInfo?.mdCode,
            store_id: this.o2oStoreId,
          },
          true
        )
      }
      if (this.isCollected === 0) {
        this.productCollection()
        if (this.$util.isSyBirdH5() || this.$util.isSyBird()) {
          const gioParams = {
            product_id: this.productId + '' || 'null',
            product_name: this.products?.productFullName + '' || 'null',
            md_code: this.storeInfo?.mdCode + '' || 'null',
            store_id: this.o2oStoreId + '' || 'null',
          }
          this.$util.gioTrackWithVariable('BD20123', gioParams)
        }
      } else if (this.isCollected === 1) {
        this.cancelProductCollection()
      }
    },

    /**
     * @description 单品页收藏接口
     */
    productCollection() {
      // if (!this.verifyTagCheckStatus()) {
      //   if (!this.$refs.goodsInfo.showInfoFlag) {
      //     this.$refs.goodsInfo.showInfoFlag = true
      //     return
      //   } else {
      //     return this.$toast('规格选择不完整')
      //   }
      // }
      const getSwiperImg = () => {
        const imgs = this.swiperImgs.length > 1 ? this.swiperImgs[1] : ''
        if (typeof imgs === 'object') {
          return imgs['img']
        } else {
          return imgs
        }
      }
      const { query } = this.$route
      const o2oStoreId = this.storeInfo ? this.storeInfo.o2oStoreId : undefined
      const param = {
        PCGName: this.location.region, // 省市区街道名称
        imageUrl: typeof this.swiperImgs[0] === 'object' ? getSwiperImg() : this.swiperImgs[0], // 图片地址
        // PCGName: this.location.region, // 省市区街道名称
        // imageUrl: typeof this.swiperImgs[0] === 'object' ? this.swiperImgs[1] : this.swiperImgs[0], // 图片地址
        productId: this.productId, // 商品ID
        productName: this.products.productName, // 商品名称
        sku: this.products.sku, // 主物料编码
        shareId: this.getShareId ? this.getShareId : undefined,
        comId: query.comId,
        undertakeStore: o2oStoreId,
        directSaleType: query.directSaleType,
      }
      this.visitStoreHandler(param)
      productCollection(param)
        .then((res) => {
          if (res.success) {
            if (res.data) {
              this.isCollected = 1
              this.$toast('收藏成功')
              // 智家app收藏埋点
              this.$util.gioTrackWithVariable('MB10802', {
                user_id: this.ucId ? this.ucId + '' : 'null',
                member_id: this.mId ? this.mId + '' : 'null',
                productId_var: this.productId + '',
                productName_var: this.products.productName || 'null',
              })
              // 新M埋点
              // gio('track', 'MB10802', {
              //   user_id: this.ucId,
              //   member_id: this.mId,
              //   productId_var: this.productId,
              // })
            } else {
              this.isCollected = 0
            }
          } else {
            this.$toast(res.message)
          }
        })
        .catch((e) => console.log(e))
    },
    /**
     * @description 单品页取消收藏
     */
    cancelProductCollection() {
      cancelProductCollection({
        sku: this.products.sku,
        // productId: this.productId, // 商品ID
      })
        .then((res) => {
          if (res.success) {
            if (res.data) {
              this.isCollected = 0
              this.$toast('取消收藏成功')
              this.$util.gioTrackWithVariable('MB13408', {
                // user_id: localStorage.getItem('ucId') ? localStorage.getItem('ucId') + '' : 'null',
                // member_id: localStorage.getItem('mId') ? localStorage.getItem('mId') + '' : 'null',
                productId_var: this.productId + '',
                // productName_var: this.products.productName || 'null'
              })
            } else {
              this.isCollected = 1
            }
          } else {
            this.$toast(res.message)
          }
        })
        .catch((e) => console.log(e))
    },

    // 点击收藏，通知洗衣机
    notifyWashingMachine() {
      if (this.taskId && this.stageId) {
        notifyWashingMachine({
          taskId: this.taskId,
          stageId: this.stageId,
        })
          .then((res) => {
            if (res.success) {
              if (res.data) {
                console.log('success')
              }
            } else {
              console.log(res.message)
            }
          })
          .catch((e) => console.log(e))
      }
    },
  },
}
